// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const ClaimForApprovalPricingSummary = t.struct({
    labor: t.Number,
    otherCredits: t.Number,
    parts: t.Number,
    total: t.Number
}, {
    name: 'ClaimForApprovalPricingSummary',
    strict: true
});

export const getDefaultState = () => new ClaimForApprovalPricingSummary({
    labor: 0,
    otherCredits: 0,
    parts: 0,
    total: 0
});

export default ClaimForApprovalPricingSummary;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-for-approval-pricing-summary.js